export const dummyData = [
    {
        "title": "Journey to Apprentice Risk",
        "value": "low"
    },
    {
        "title": "Partner Risk",
        "value": "low"
    },
    {
        "title": "Prevailing Wage Risk",
        "value": "low"
    },
    {
        "title": "Project Documentation Risk",
        "value": "low"
    }
]